'use client';

import React from 'react';
import Link from 'next/link';

export default function PrivacyPolicyPage() {
  return (
    <main style={{ fontFamily: "'DM Sans', 'Roboto', sans-serif", minHeight: '100vh', background: '#f8fafc' }}>
      {/* Navbar */}
      <nav style={{ backgroundColor: '#fff', padding: '16px 0', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
            <img src="/assets/images/image-1778102925137.png" alt="HP Logo" width={91} height={61} style={{ objectFit: 'contain' }} />
          </Link>
          <Link href="/" style={{ color: 'rgb(49,107,156)', textDecoration: 'none', fontSize: '15px', fontWeight: 600 }}>← Back to Store</Link>
        </div>
      </nav>

      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg, #003366 0%, #0d5fa3 100%)', padding: '48px 40px', textAlign: 'center' }}>
        <h1 style={{ color: '#fff', fontSize: '36px', fontWeight: 800, margin: '0 0 12px' }}>Privacy Policy</h1>
        <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '16px', margin: 0 }}>Last updated: January 1, 2026</p>
      </div>

      {/* Content */}
      <div style={{ maxWidth: '860px', margin: '0 auto', padding: '48px 40px' }}>
        <div style={{ background: '#fff', borderRadius: '16px', padding: '48px', boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>1. Introduction</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              Barb Printer Store ("we," "our," or "us") is committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and make purchases. Please read this policy carefully. If you disagree with its terms, please discontinue use of our site.
            </p>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>2. Information We Collect</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px', marginBottom: '12px' }}>We may collect the following types of information:</p>
            <ul style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '8px' }}><strong>Personal Identification Information:</strong> Name, email address, phone number, billing and shipping address.</li>
              <li style={{ marginBottom: '8px' }}><strong>Payment Information:</strong> Credit/debit card details processed securely through our payment processor. We do not store full card numbers.</li>
              <li style={{ marginBottom: '8px' }}><strong>Device & Usage Data:</strong> IP address, browser type, operating system, pages visited, time spent on pages, and referring URLs.</li>
              <li style={{ marginBottom: '8px' }}><strong>Cookies & Tracking Technologies:</strong> We use cookies to enhance your browsing experience, analyze site traffic, and personalize content.</li>
            </ul>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>3. How We Use Your Information</h2>
            <ul style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '8px' }}>Process and fulfill your orders</li>
              <li style={{ marginBottom: '8px' }}>Send order confirmations and shipping updates</li>
              <li style={{ marginBottom: '8px' }}>Respond to customer service inquiries</li>
              <li style={{ marginBottom: '8px' }}>Improve our website and product offerings</li>
              <li style={{ marginBottom: '8px' }}>Send promotional communications (with your consent)</li>
              <li style={{ marginBottom: '8px' }}>Comply with legal obligations</li>
              <li style={{ marginBottom: '8px' }}>Detect and prevent fraud</li>
            </ul>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>4. Cookies Policy</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px', marginBottom: '12px' }}>
              We use cookies and similar tracking technologies to track activity on our website and hold certain information. Cookies are files with a small amount of data which may include an anonymous unique identifier.
            </p>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our website. We use Google Analytics and Google Ads cookies to measure and improve our advertising performance.
            </p>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>5. Third-Party Disclosure</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties except to trusted third parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when its release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property, or safety.
            </p>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>6. Google Advertising</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              We use Google AdSense and Google Ads to display advertisements. Google uses cookies to serve ads based on your prior visits to our website or other websites. You may opt out of personalized advertising by visiting <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer" style={{ color: 'rgb(49,107,156)' }}>Google Ads Settings</a>. We comply with Google's advertising policies, including those related to interest-based advertising.
            </p>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>7. Data Security</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>8. Your Rights</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px', marginBottom: '12px' }}>Depending on your location, you may have the following rights:</p>
            <ul style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '8px' }}>Right to access your personal data</li>
              <li style={{ marginBottom: '8px' }}>Right to correct inaccurate data</li>
              <li style={{ marginBottom: '8px' }}>Right to request deletion of your data</li>
              <li style={{ marginBottom: '8px' }}>Right to opt out of marketing communications</li>
              <li style={{ marginBottom: '8px' }}>Right to data portability (GDPR)</li>
            </ul>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px', marginTop: '12px' }}>
              To exercise these rights, please contact us at <a href="mailto:privacy@barbprinterstore.online" style={{ color: 'rgb(49,107,156)' }}>privacy@barbprinterstore.online</a>.
            </p>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>9. Children's Privacy</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              Our website is not directed to children under the age of 13. We do not knowingly collect personally identifiable information from children under 13. If you are a parent or guardian and you are aware that your child has provided us with personal data, please contact us.
            </p>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>10. Changes to This Policy</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date. You are advised to review this Privacy Policy periodically for any changes.
            </p>
          </section>

          <section>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>11. Contact Us</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              If you have any questions about this Privacy Policy, please contact us:<br />
              <strong>Email:</strong> <a href="mailto:privacy@barbprinterstore.online" style={{ color: 'rgb(49,107,156)' }}>privacy@barbprinterstore.online</a><br />
              <strong>Website:</strong> <a href="/" style={{ color: 'rgb(49,107,156)' }}>barbprinterstore.online</a>
            </p>
          </section>
        </div>
      </div>

      {/* Footer */}
      <footer style={{ background: '#1e293b', padding: '32px 40px', marginTop: '40px' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
          <span style={{ color: '#94a3b8', fontSize: '14px' }}>© 2026 Barb Printer Store. All Rights Reserved.</span>
          <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
            <Link href="/privacy-policy" style={{ color: '#7dd3fc', textDecoration: 'none', fontSize: '14px' }}>Privacy Policy</Link>
            <Link href="/terms-and-condition" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '14px' }}>Terms of Service</Link>
            <Link href="/refund-policy" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '14px' }}>Refund Policy</Link>
            <Link href="/contact-us" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '14px' }}>Contact</Link>
          </div>
        </div>
      </footer>
    </main>
  );
}
